export const CUSTOM_BREAKPOINT = 1325;

export const ONE_TRUST_COOKIE_NAME = 'OptanonConsent';

export const SUBTITLE_100_02 = 'subtitle-100-02';
export const SUBTITLE_100_04 = 'subtitle-100-04';

export * from './api';
